module.exports = __webpack_public_path__ + "f5fa94dd1c3a6e6d003dd3df5244ce97.png";